import 'boxicons/css/boxicons.min.css'
import { Banner, Footer } from 'component-library'
import CoachMarkGatsbyRoot from 'component-library/gatsby'
import { Script } from 'gatsby'
import { ReactNode } from 'react'
import { BannerContent, FooterContent } from 'shared-content'
import { getCurrentEnvConfig } from '../../../config'
import AuthProvider from '../AuthProvider/AuthProvider'
import LinkComponent from '../LinkComponent/LinkComponent'
import MarkdownText from '../MarkdownText/MarkdownText'
import MathJax from '../MathJax/MathJax'
import NavBarWrapper from '../NavBarWrapper/NavBarWrapper'

interface ILayoutProps {
  children?: ReactNode
}

const Layout = ({ children }: ILayoutProps) => {
  const { widget_url } = getCurrentEnvConfig()

  return (
    <AuthProvider>
      <>
        <NavBarWrapper />
        {BannerContent.bannerText.length > 0 && (
          <Banner
            bannerText={<MarkdownText text={BannerContent.bannerText} />}
          />
        )}
        <div className="relative">{children}</div>
        <CoachMarkGatsbyRoot />
        <Footer
          footerDescription={
            <MarkdownText text={FooterContent.footerAbout.description} />
          }
          footerCreatedBy={
            <MarkdownText
              text={FooterContent.footerAbout.createdBy}
              gaEventCategory="footer_ux"
              gaEventLabel="footer_xanadu_click"
              gaEventValue="redirect to xanadu homepage"
            />
          }
          {...FooterContent}
          LinkComponent={LinkComponent}
        />
        <Script src={widget_url} type="module" />
        {/* @ts-expect-error: Custom element not in JSX.IntrinsicElements */}
        <pennylane-help></pennylane-help>
        <MathJax />
      </>
    </AuthProvider>
  )
}

export default Layout
